import FingerprintJS from '@fingerprintjs/fingerprintjs';

// Cookie name for storing device ID
const DEVICE_ID_COOKIE = 'clipo_device_id';
const DEVICE_AUTH_COOKIE = 'clipo_device_auth';

// Get device fingerprint ID
export const getDeviceId = async (): Promise<string> => {
  const fp = await FingerprintJS.load();
  const result = await fp.get();
  return result.visitorId;
};

// Set device ID cookie
export const setDeviceIdCookie = (deviceId: string): void => {
  document.cookie = `${DEVICE_ID_COOKIE}=${deviceId};path=/;max-age=31536000`; // 1 year
};

// Get device ID from cookie
export const getDeviceIdFromCookie = (): string | null => {
  const match = document.cookie.match(new RegExp(`(^| )${DEVICE_ID_COOKIE}=([^;]+)`));
  return match ? match[2] : null;
};

// Set authentication status cookie
export const setDeviceAuthCookie = (isAuthenticated: boolean): void => {
  document.cookie = `${DEVICE_AUTH_COOKIE}=${isAuthenticated ? 'true' : 'false'};path=/;max-age=31536000`; // 1 year
};

// Get authentication status from cookie
export const getDeviceAuthFromCookie = (): boolean => {
  const match = document.cookie.match(new RegExp(`(^| )${DEVICE_AUTH_COOKIE}=([^;]+)`));
  return match ? match[2] === 'true' : false;
};

// Setup device ID - generate if not exists, then validate with server
export const setupDeviceId = async (): Promise<string> => {
  let deviceId = getDeviceIdFromCookie();
  
  if (!deviceId) {
    deviceId = await getDeviceId();
    setDeviceIdCookie(deviceId);
  }
  
  return deviceId;
};

// Debug function to log device cookie values
export const logDeviceCookies = (): { id: string | null, auth: boolean } => {
  const deviceId = getDeviceIdFromCookie();
  const authStatus = getDeviceAuthFromCookie();
  
  console.log('Device Cookies:', {
    'Device ID': deviceId || 'Not set',
    'Auth Status': authStatus
  });
  
  return { id: deviceId, auth: authStatus };
};

// Force update device auth cookie based on server data
export const updateDeviceAuthCookie = (deviceId: string, devices: any[]): boolean => {
  const device = devices.find(d => d.deviceId === deviceId);
  
  if (device) {
    const serverAuthStatus = !!device.isAuthorized;
    const currentAuthStatus = getDeviceAuthFromCookie();
    
    console.log('Auth status comparison:', {
      'Server status': serverAuthStatus,
      'Cookie status': currentAuthStatus
    });
    
    // Update the cookie if it doesn't match server
    if (serverAuthStatus !== currentAuthStatus) {
      console.log('Updating auth cookie to match server:', serverAuthStatus);
      setDeviceAuthCookie(serverAuthStatus);
      return true;
    }
  }
  
  return false;
};